import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
// import { messageTooltipContentClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const CommentButton: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        top: pxToRem(-1),
        height: pxToRem(36),
        [`&.${buttonClassName}`]: {
            marginLeft: pxToRem(10),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(16),
                height: pxToRem(18),
            },
        },
        [`& .${svgIconClassName}`]: {
            marginLeft: pxToRem(2),
            marginRight: pxToRem(2),
            position: 'relative',
        },
    },
});

export const LinkToButton: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        top: pxToRem(-1),
        height: pxToRem(36),
        [`&.${buttonClassName}`]: {
            marginLeft: pxToRem(10),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(18),
                height: pxToRem(18),
            },
        },
        [`& .${svgIconClassName}`]: {
            width: pxToRem(20),
            position: 'relative',
        },
    },
});

export const ShareButton: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        top: pxToRem(-1),
        height: pxToRem(36),
        [`&.${buttonClassName}`]: {
            marginLeft: pxToRem(11),
            paddingLeft: pxToRem(6),
            paddingRight: pxToRem(6),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(16),
                height: pxToRem(18),
            },
        },
        [`& .${svgIconClassName}`]: {
            width: pxToRem(15),
            position: 'relative',
        },
    },
});

export const DeleteButton: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        top: pxToRem(-1),
        position: 'relative',
        padding: pxToRem(5),
        [`& .${svgIconClassName}`]: {
            position: 'relative',
        },
        [`&.${buttonClassName}`]: {
            marginLeft: pxToRem(10),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(18),
                height: pxToRem(18),
            },
        },
    },
});

export const MessageToolTipStyle: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        [`& > .${buttonClassName}`]: {
            marginLeft: pxToRem(8),
        },
    },
});
